import { __decorate } from "tslib";
import { injectable } from "inversify";
import { reaction } from "mobx";
var DisposeHelper = /** @class */ (function () {
    function DisposeHelper() {
        this.registeredReactions = [];
        this.registeredDisposables = [];
    }
    /**
     * Registers a mobx reaction, which will be disposed in the dispose() method when the view is unmounted.
     * @param expression Expression to react to.
     * @param effect Callback to run when the result of the expression changes.
     */
    DisposeHelper.prototype.registerReaction = function (expression, effect) {
        var _this = this;
        var disposer = reaction(function () { return expression(_this); }, effect);
        this.registeredReactions.push(disposer);
        return disposer;
    };
    DisposeHelper.prototype.autoDispose = function (disposable) {
        this.registeredDisposables.push(disposable);
        return disposable;
    };
    DisposeHelper.prototype.dispose = function () {
        for (var _i = 0, _a = this.registeredReactions; _i < _a.length; _i++) {
            var disposer = _a[_i];
            disposer();
        }
        this.registeredReactions = [];
        for (var _b = 0, _c = this.registeredDisposables; _b < _c.length; _b++) {
            var disposable = _c[_b];
            disposable.dispose();
        }
        this.registeredDisposables = [];
    };
    DisposeHelper = __decorate([
        injectable()
    ], DisposeHelper);
    return DisposeHelper;
}());
export { DisposeHelper };
